var _title, _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChartSkeletonDarkMode = props => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "loading-aria",
  viewBox: "0 0 321 280",
  preserveAspectRatio: "none"
}, props), _title || (_title = /*#__PURE__*/React.createElement("title", {
  id: "loading-aria"
}, "Loading...")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 0,
  y: 0,
  width: "100%",
  height: "100%",
  clipPath: "url(#clip-path)",
  fill: "url(#fill)"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path"
}, /*#__PURE__*/React.createElement("path", {
  d: "M61 21h2v218h-2zm232 216v2H63v-2z"
}), /*#__PURE__*/React.createElement("rect", {
  x: 28,
  y: 234,
  rx: 2,
  ry: 2,
  width: 24,
  height: 8
}), /*#__PURE__*/React.createElement("rect", {
  x: 77,
  y: 244,
  rx: 2,
  ry: 2,
  width: 16,
  height: 16
}), /*#__PURE__*/React.createElement("rect", {
  x: 113,
  y: 244,
  rx: 2,
  ry: 2,
  width: 16,
  height: 16
}), /*#__PURE__*/React.createElement("rect", {
  x: 149,
  y: 244,
  rx: 2,
  ry: 2,
  width: 16,
  height: 16
}), /*#__PURE__*/React.createElement("rect", {
  x: 185,
  y: 244,
  rx: 2,
  ry: 2,
  width: 16,
  height: 16
}), /*#__PURE__*/React.createElement("rect", {
  x: 221,
  y: 244,
  rx: 2,
  ry: 2,
  width: 16,
  height: 16
}), /*#__PURE__*/React.createElement("rect", {
  x: 257,
  y: 244,
  rx: 2,
  ry: 2,
  width: 16,
  height: 16
}), /*#__PURE__*/React.createElement("rect", {
  x: 28,
  y: 201,
  rx: 2,
  ry: 2,
  width: 24,
  height: 8
}), /*#__PURE__*/React.createElement("rect", {
  x: 28,
  y: 168,
  rx: 2,
  ry: 2,
  width: 24,
  height: 8
}), /*#__PURE__*/React.createElement("rect", {
  x: 28,
  y: 135,
  rx: 2,
  ry: 2,
  width: 24,
  height: 8
}), /*#__PURE__*/React.createElement("rect", {
  x: 28,
  y: 102,
  rx: 2,
  ry: 2,
  width: 24,
  height: 8
}), /*#__PURE__*/React.createElement("rect", {
  x: 28,
  y: 69,
  rx: 2,
  ry: 2,
  width: 24,
  height: 8
}), /*#__PURE__*/React.createElement("rect", {
  x: 28,
  y: 36,
  rx: 2,
  ry: 2,
  width: 24,
  height: 8
}), /*#__PURE__*/React.createElement("rect", {
  x: 72,
  y: 196,
  rx: 2,
  ry: 2,
  width: 25,
  height: 43
}), /*#__PURE__*/React.createElement("rect", {
  x: 108,
  y: 158,
  rx: 2,
  ry: 2,
  width: 25,
  height: 81
}), /*#__PURE__*/React.createElement("rect", {
  x: 144,
  y: 135,
  rx: 2,
  ry: 2,
  width: 25,
  height: 104
}), /*#__PURE__*/React.createElement("rect", {
  x: 180,
  y: 105,
  rx: 2,
  ry: 2,
  width: 25,
  height: 134
}), /*#__PURE__*/React.createElement("rect", {
  x: 216,
  y: 73,
  rx: 2,
  ry: 2,
  width: 25,
  height: 166
}), /*#__PURE__*/React.createElement("rect", {
  x: 252,
  y: 32,
  rx: 2,
  ry: 2,
  width: 25,
  height: 207
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "fill"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.599964,
  stopColor: "#082F49",
  stopOpacity: 1
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "offset",
  values: "-2; -2; 1",
  keyTimes: "0; 0.25; 1",
  dur: "2s",
  repeatCount: "indefinite"
})), /*#__PURE__*/React.createElement("stop", {
  offset: 1.59996,
  stopColor: "#1E293B",
  stopOpacity: 1
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "offset",
  values: "-1; -1; 2",
  keyTimes: "0; 0.25; 1",
  dur: "2s",
  repeatCount: "indefinite"
})), /*#__PURE__*/React.createElement("stop", {
  offset: 2.59996,
  stopColor: "#082F49",
  stopOpacity: 1
}, /*#__PURE__*/React.createElement("animate", {
  attributeName: "offset",
  values: "0; 0; 3",
  keyTimes: "0; 0.25; 1",
  dur: "2s",
  repeatCount: "indefinite"
}))))));
export default SvgChartSkeletonDarkMode;